import {
  ButtonIcon,
  EditActionIcon,
  DeleteActionIcon,
} from 'components/Ui/styled';
import { format } from 'date-fns';
import { ActionWrapperBox } from 'components/Common/common.styled';
import { dateFnsFormat } from 'constants';
import { renderCellExpand } from 'components/Common/GridCell/GridCellExpand';

const renderSubjectTimeBlocksActions = (params, handleEdit, handleDelete) => {
  return (
    <ActionWrapperBox>
      <ButtonIcon onClick={() => handleEdit(params)}>
        <EditActionIcon />
      </ButtonIcon>
      <ButtonIcon onClick={() => handleDelete(params)}>
        <DeleteActionIcon />
      </ButtonIcon>
    </ActionWrapperBox>
  );
};

export const tutoringSubjectsColumns = (handleEdit, handleDelete) => [
  {
    field: 'action',
    headerName: 'Action',
    sortable: false,
    disableColumnMenu: true,
    width: 80,
    renderCell: (params) =>
      renderSubjectTimeBlocksActions(params, handleEdit, handleDelete),
  },
  {
    headerName: 'Subject',
    field: 'subjectName',
    renderCell: renderCellExpand,
    flex: 1,
  },
  { headerName: 'Starts At', field: 'startsAt', flex: 1 },
  { headerName: 'Ends At', field: 'endsAt', flex: 1 },
  { headerName: 'Cancelled Sessions', field: 'cancelledSessions', flex: 1 },
  {
    headerName: 'Reason',
    field: 'reason',
    renderCell: renderCellExpand,
    flex: 1,
  },
];

export const getSubjectTimeBlocksListData = (
  subjectTimeBlocksData,
  subjectsList
) => {
  if (!subjectTimeBlocksData || subjectTimeBlocksData?.length === 0) {
    return [];
  }

  return subjectTimeBlocksData.map((item) => {
    const matchedSubject = subjectsList?.find(
      (subject) => subject?.subjectId === item?.subjectId
    );

    const subjectName = matchedSubject ? matchedSubject?.name : '';

    return {
      ...item,
      id: item?.timeBlockId,
      reason: item?.reason,
      subjectName: subjectName,
      startsAt: format(new Date(item.startsAt), dateFnsFormat),
      endsAt: format(new Date(item.endsAt), dateFnsFormat),
    };
  });
};
